/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_S3Inputs */

const en_mk_tut_agen_s3 = /** @type {(inputs: Mk_Tut_Agen_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About fifteen seconds later the status becomes **In review** and the result lands as an ordinary comment on the same issue.`)
};

const id_mk_tut_agen_s3 = /** @type {(inputs: Mk_Tut_Agen_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekitar 15 detik kemudian status menjadi **Perlu review** dan hasil kerjanya masuk sebagai komentar biasa di issue yang sama.`)
};

/**
* | output |
* | --- |
* | "About fifteen seconds later the status becomes **In review** and the result lands as an ordinary comment on the same issue." |
*
* @param {Mk_Tut_Agen_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_s3 = /** @type {((inputs?: Mk_Tut_Agen_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_s3(inputs)
	return en_mk_tut_agen_s3(inputs)
});